import Vue from "vue";
import store from "@store/index";

export default function vailCode(rs, callback, errcallback, type) {
  if (!rs) {
    typeof errcallback == "function" && errcallback(rs);
    return;
  }
  if (rs.code == 0) {
    typeof callback == "function" && callback(rs);
  } else {
    if (rs.code === 401 || rs.code === 10001) {
      typeof errcallback == "function" && errcallback(rs);
    } else if (type === "refCode" || type === "init") {
      typeof errcallback == "function" && errcallback(type);
    } else {
      Vue.toasted.clear();
      Vue.toasted.error(rs.message);
      typeof errcallback == "function" && errcallback(rs);
    }
  }
}
